import { isNull } from 'lodash';
import APIEndpoints from '../utils/apiEndpoints';
import AbstractService from './abstractService';

// Singleton instance
let instance = null;

const _SERVICE_UNAVAILABLE_ = new Error({ message : 'Service Unavailable' });

export default class ApplicationService extends AbstractService {
	static setup(baseURL, options) {
		instance = new ApplicationService(baseURL, options);
	}

	static getInstance() {
		return instance;
	}

	constructor(baseURL, options) {
		super(baseURL, options);
		this.endpoints = {
			USStates      : APIEndpoints.USStates,
			timeZones     : APIEndpoints.timeZones,
			paymentTerms  : APIEndpoints.paymentTerms,
			vehicleTypes  : APIEndpoints.vehicleTypes,
			locationTypes : APIEndpoints.locationTypes,
		};
	}

	static getPaymentTerms() {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getPaymentTerms();
	}

	static getUSStates() {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getUSStates();
	}

	static getTimeZones() {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getTimeZones();
	}

	static getVehicleTypes(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getVehicleTypes(...params);
	}

	static getLocationTypes(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getLocationTypes(...params);
	}

	_getPaymentTerms() {
		return this.get({ endpoint : this.endpoints.paymentTerms });
	}

	_getUSStates() {
		return this.get({ endpoint : this.endpoints.USStates });
	}

	_getTimeZones() {
		return this.get({ endpoint : this.endpoints.timeZones });
	}

	_getVehicleTypes() {
		return this.get({ endpoint : this.endpoints.vehicleTypes });
	}

	_getLocationTypes() {
		return this.get({ endpoint : this.endpoints.locationTypes });
	}
}
